<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-list" class="q-mb-sm" /> {{ $t('redeems') }}
        </div>

        <q-table
            :data="redeems"
            :columns="columns"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            :filter="filter"
            row-key="name"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
        >

            <template slot="top" slot-scope="props" :props="props">
                <q-search v-model="filter" icon="far fa-search" :placeholder="$t('search')" :debounce="500" />
                <div class="col" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="order_number" :props="props">
                    {{ props.row.order_number }}
                </q-td>

                <q-td key="reward_title" :props="props">
                    {{ props.row.reward_title }}
                </q-td>

                <q-td key="price" :props="props">
                    {{ props.row.price ? Math.round(props.row.price*100)/100 : 0 }}
                </q-td>

                <q-td key="created_date" :props="props">
                    {{ props.row.created_date }}
                </q-td>

                <q-td key="full_name" :props="props">
                    {{ props.row.full_name }}
                </q-td>

                <q-td key="campaign" :props="props">
                    {{ props.row.campaign }}
                </q-td>

                <q-td key="status" :props="props" auto-width >
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" >
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

                <q-td key="actions" :props="props">
                    <q-btn flat round color="primary" icon="far fa-search" @click="$router.push({ name: 'reward_order', params: { id: props.row.actions } })" />
                </q-td>
            </q-tr>
        </q-table>

        <q-dialog v-model="confirm_remove" @ok="removeItem">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props" :props="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeItem()" />
            </template>
        </q-dialog>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import { LocalStorage } from 'quasar'
import { date } from 'quasar'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "tags", "admin", "rewards" ] },

    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            loading: false,
            redeems: [],
            columns: [
                {
                    name: 'order_number',
                    required: true,
                    label: 'order_number',
                    align: 'left',
                    field: 'order_number',
                    sortable: true,
                },
                {
                    name: 'reward_title',
                    required: true,
                    label: 'reward_title',
                    align: 'left',
                    field: 'reward_title',
                    sortable: true,
                },
                {
                    name: 'price',
                    required: true,
                    label: 'price',
                    align: 'left',
                    field: 'price',
                    sortable: true,
                },
                {
                    name: 'created_date',
                    required: true,
                    label: 'redeem_date',
                    align: 'left',
                    field: 'created_date',
                    sortable: true,
                },
                {
                    name: 'full_name',
                    required: true,
                    label: 'full_name',
                    align: 'left',
                    field: 'full_name',
                    sortable: true,
                },
                {
                    name: 'campaign',
                    required: true,
                    label: 'campaign',
                    align: 'left',
                    field: 'campaign',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: true,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    sortable: false,
                },
            ],
            filter: '',
            action_id: '',
            confirm_remove: false
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_client_country_selected: 'common/id_user_client_country_selected',
            reload_content: 'common/reload_content',
            areas: 'registration_lists/country_areas',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        request ({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }
            this.saveFilter();
            this.savePagination()

            this.$axios.get('/admin_rewards/rewards_orders/?'+ this.$qs.stringify(data), this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.redeems = []
                response.data.results.forEach(result => {
                    this.redeems.push({
                        id: result.id,
                        order_number: result.order_number,
                        reward_title: result.reward_title,
                        reward: result.reward,
                        reward_type: result.reward_type,
                        email: result.email,
                        phone_mobile: result.phone_mobile,
                        address: result.address,
                        full_name: result.full_name,
                        price: result.price,
                        status: result.status,
                        created_date: date.formatDate(result.created_date, 'DD/MM/YYYY HH:mm:ss'),
                        updated_date: date.formatDate(result.updated_date, 'DD/MM/YYYY HH:mm:ss'),
                        reward_redeen_code: result.reward_redeen_code,
                        history: result.history,
                        user_points: result.user_points,
                        user_sales: result.user_sales,
                        campaign: result.campaign,
                        actions: result.id
                    })
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        fetchLists() {
            this.$q.loading.show()

            this.$axios.get('/accounts/get_registration_lists/', this.getHeader)
            .then(response => {
                this.$store.dispatch('registration_lists/SET_LISTS', [response.data])
                this.$q.loading.hide()

                this.request({
                    pagination: this.server_pagination
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        confirmRemove(id) {
            this.action_id = id
            this.confirm_remove = true
        },

        removeItem() {
            this.$q.loading.show()

            this.$axios.delete(`/admin_rewards/categories/${this.action_id}/`, this.getHeader)
            .then(response => {
                this.$q.loading.hide()

                this.request({
                    pagination: this.server_pagination
                })

                this.confirm_remove = false

                this.$q.notify({
                    message: this.$t('item_removed_success'),
                    type: 'positive',
                    icon: 'far fa-trash-alt'
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        getStatus(status) {
            if (status == 1) return 'awaiting_approval'
            else if (status == 2) return 'approved'
            else if (status == 3) return 'reproved'
            else if (status == 4) return 'shipped'
            else if (status == 5) return 'delivered'
            else return ''
        },


        getIconStatus(status) {
            if (status == 1) return 'fal fa-hourglass-half'
            else if (status == 2) return 'fal fa-check-double'
            else if (status == 3) return 'fal fa-times'
            else if (status == 4) return 'fal fa-shipping-fast'
            else if (status == 5) return 'fal fa-hand-holding-box'
            else return ''
        },

        getColorStatus(status) {
            if (status == 1) return 'amber'
            else if (status == 2) return 'positive'
            else if (status == 3) return 'negative'
            else if (status == 4) return 'orange'
            else if (status == 5) return 'light-green'
            else return ''
        },

        saveFilter() {
            let dataTableRedeems = {
                "rowsPerPage": this.server_pagination.rowsPerPage,
                "filter": this.filter
            }
            this.$q.localStorage.set('dataTableRedeems', dataTableRedeems)

        },

        loadFilter() {
            if (this.$q.localStorage.has('redeemsRedeems')) {
            let redeems = this.$q.localStorage.get.item('dataTableRedeems')
            this.server_pagination.rowsPerPage = redeems.rowsPerPage
            this.filter = redeems.filter
          }
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        }
    },

    watch: {
        reload_content: function() {
            this.request({
                pagination: this.server_pagination
            })
        }
    },

    created() {
      this.loadFilter()
      this.loadPagination()
      this.fetchLists()
    }
}
</script>

<style lang="stylus" scoped>

</style>
